import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-style-three',
  templateUrl: './pricing-style-three.component.html',
  styleUrls: ['./pricing-style-three.component.scss']
})
export class PricingStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
